import React from "react";
import PropTypes from "prop-types";
import { Folder, Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const CategoryCard = ({ category, handleCategorySelect }) => {
  const categoryImage = category.media?.[0]?.url || category.image;
  const isFeatured = Boolean(
    category.is_featured === true ||
    category.is_featured === 1 ||
    category.is_featured === "1" ||
    category.is_featured === "true",
  );

  return (
    <Card
      key={category.id}
      onClick={() => handleCategorySelect(category.id)}
      className="relative cursor-pointer transition-all duration-200 hover:shadow-md border-border overflow-hidden hover:border-primary/50 group w-full aspect-square flex flex-col items-center justify-center select-none"
    >
      {/* Featured Corner Label */}
      {isFeatured && (
        <div className="absolute top-0 right-0 z-10">
          <div className="bg-warning text-white text-[10px] font-bold px-2 py-0.5 rounded-bl-lg shadow-xs flex items-center gap-1 leading-none tracking-wide">
            <Star size={9} fill="currentColor" />
            <span>Featured</span>
          </div>
        </div>
      )}

      <CardContent className="p-2.5 sm:p-3 flex flex-col items-center justify-center text-center h-full w-full gap-1.5 sm:gap-2">
        {/* Image / Icon Section */}
        <div className="w-12 h-12 sm:w-14 sm:h-14 shrink-0 bg-secondary/10 rounded-xl overflow-hidden border border-secondary/20 flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
          {categoryImage ? (
            <img
              src={categoryImage}
              alt={category.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <Folder
              size={24}
              className="text-muted-foreground/60 group-hover:text-primary transition-colors"
            />
          )}
        </div>

        {/* Category Details (down by down) */}
        <div className="w-full px-1 flex flex-col items-center justify-center min-w-0">
          <h6
            className="font-semibold text-xs sm:text-sm leading-snug line-clamp-2 sm:line-clamp-3 text-foreground group-hover:text-primary transition-colors break-words text-center"
            title={category.name}
          >
            {category.name}
          </h6>
        </div>
      </CardContent>
    </Card>
  );
};

CategoryCard.propTypes = {
  category: PropTypes.object.isRequired,
  handleCategorySelect: PropTypes.func.isRequired,
};

export default CategoryCard;
